export const LANDING_EVENTS_WITH_MAX_DIMENSION_RULES_COUNT = 3;
